<template>
  <div>
    <h3 class="pt-3">
      Criteria Not Met--{{ tableHeaderDisplayName }}
      <app-tooltip right nudge-left="140">
        <template #activator="{ on }">
          <sup><v-icon small class="material-icons-round" v-on="on">info</v-icon></sup>
        </template>
        <span
          >The list of criteria not met when patients were Identified but later marked Not for the
          trial</span
        >
      </app-tooltip>
    </h3>
    <criteria-not-met-table :trial-id="trialId" :org-id="orgId" />
  </div>
</template>

<script>
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import CriteriaNotMetTable from '@/components/insights/CriteriaNotMetTable'
import { SubTableTypes } from '@/helpers/table-helper'

export default {
  components: { CriteriaNotMetTable },
  props: {
    trialId: { type: String, default: null },
    tableHeaderDisplayName: { type: String, default: null }
  },
  data() {
    return {
      selectedTable: null,
      title: null,
      tooltip: null
    }
  },
  computed: {
    orgId() {
      return MyActiveOrganization.id
    },
    showCriteriaNotMet() {
      return this.selectedTable === SubTableTypes.notEligible.CRITERIA_NOT_MET
    },
    showReasons() {
      return this.selectedTable === SubTableTypes.notEligible.REASONS
    }
  },
  methods: {
    onTableChange(selectedTable) {
      this.selectedTable = selectedTable.value
      this.title = selectedTable.text
      this.tooltip = selectedTable.tooltip
    }
  }
}
</script>
